import { render, staticRenderFns } from "./MainCategoryItem.vue?vue&type=template&id=10344559&scoped=true"
import script from "./MainCategoryItem.vue?vue&type=script&lang=js"
export * from "./MainCategoryItem.vue?vue&type=script&lang=js"
import style0 from "./MainCategoryItem.vue?vue&type=style&index=0&id=10344559&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10344559",
  null
  
)

export default component.exports